import { render } from "./PageVideoReferanslar.vue?vue&type=template&id=7dc4f0eb"
import script from "./PageVideoReferanslar.vue?vue&type=script&lang=js"
export * from "./PageVideoReferanslar.vue?vue&type=script&lang=js"
script.render = render

export default script